
import { mapGetters } from 'vuex'
import SkeletonSpinner from '~/components/common/loading/SkeletonSpinner.vue'

export default {
  name: 'LoadingBar',
  components: { SkeletonSpinner },
  computed: {
    ...mapGetters('loading', ['isLoading', 'isGlobalLoadingBarSuppressed']),
    shouldShowLoading () {
      return this.isLoading && !this.isGlobalLoadingBarSuppressed
    }
  },
  // props: {
  //   showLoadingBar: { type: Boolean, default: false }
  // }
}
